<template>
  <v-list>
    <v-list-tile
      v-for="(item) in items"
      :key="item.item_id"
      class="lighten-3 my-2 list-item"
    >
      <v-list-tile-action>
        {{ item.quantity }} / {{ item.max }}
      </v-list-tile-action>

      <v-list-tile-avatar>
        <v-img :src="item.image || '/static/product_placeholder_2.png'"/>
      </v-list-tile-avatar>

      <v-list-tile-content>
        <v-list-tile-title>
          <router-link
            :to="{
              name: 'single-product',
              params: { id: item.item_id }
            }"
            class="subheading"
          >
            {{ item.name }}
          </router-link>
        </v-list-tile-title>
        <v-list-tile-sub-title class="text-uppercase">
          <span>{{ $t('SKU:') }} {{ item.sku }}</span>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  name: 'OrderSingleShipmentItems',

  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>
